import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { QuestionService } from 'src/app/manage/questionanswer/service/question.service';
import { ContestService } from 'src/app/services/contest.service';
@Component({
  selector: 'app-contest-match-stats',
  templateUrl: './contest-match-stats.component.html',
  styleUrls: ['./contest-match-stats.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class ContestMatchStatsComponent implements OnInit {
  public loggedInUser: any;
  public isLoggedIn: boolean = false;
  public loginRegisterModal: boolean = false;
  public showMobileLoginOtpForm: boolean = false;
  public userId;
  public termsAndConditionsCheck: boolean = false;
  public dontShowAgainCheck: boolean = false;
  public showTermsAndConditionError: boolean = false;
  public showDontShowAgainError: boolean = false;
  public showSelectedPlayerError: boolean = false;
  public showPlayers: boolean = false;
  public showContestDetailSection: boolean = true;
  public showQuestions: boolean = false;
  public loading: boolean = false;
  public contestId;
  public questionsList: any = [];
  public totalRecords;
  public errorMessage;
  public contestDetails: any = [];
  public playersData: any = [];
  public selectedPlayerName = undefined;
  public userContestId: any;
  public selectedQuestions: any = [];
  public showQuestionsError: boolean = false;
  public showThankYou: boolean = false;
  public selectedPlayerId;
  public matchId;
  public contestMatchStatistics;
  contestMatchSetPointsStats: any;
  setPoints:number[] = [1,2,3,4,5];
  isContestDoubles: boolean;
  constructor(
    // private formBuilder: FormBuilder,
    // private messageService: MessageService,
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private questionService: QuestionService,
    private activatedRoute: ActivatedRoute,
    private contestService: ContestService,
    private renderer: Renderer2,
  ) {
  }
  ngOnInit(): void {
    this.renderer.addClass(document.body, 'match-status-page');
    // this.contestId = this.activatedRoute.snapshot.paramMap.get("contestId");
    this.userContestId = this.activatedRoute.snapshot.paramMap.get("userContestId");
    this.loggedInUser = this.tokenStorageService.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
    }
    if (this.isLoggedIn == false) {
      let currentUrl = '/';
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    }
    this.matchId = this.activatedRoute.snapshot.paramMap.get("matchId");
    this.getUserContestMatchStatistics(this.matchId);
    this.getContestMatchSetPoints(this.matchId);
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'match-status-page');
  }
  getUserContestMatchStatistics(matchId) {
    let query = "?filterByDisable=false&filterByMatchId=" + matchId;
    this.contestService.getContestMatchStats(query).subscribe(
      async data => {
        this.contestMatchStatistics = data['data'].items[0];
        this.isContestDoubles = (this.contestMatchStatistics?.player1Name.split('/').length === 2 && this.contestMatchStatistics?.player2Name.split('/').length === 2) ? true : false;
        //await this.getContestDetails();
      },
      err => {
      }
    );
  }

  getContestMatchSetPoints(matchId) {
    this.contestService.getContestMatchSetPoints(matchId).subscribe((data:any)=>{
      this.contestMatchSetPointsStats = data.event;
    })
  }

  async getContestDetails() {
    this.contestService.getContestDetails(this.contestId).subscribe(async res => {
      this.contestDetails = res;
      this.matchId = this.contestDetails.matchId;
      this.playersData = [
        {
          name: this.contestDetails.player1Name,
          id: this.contestDetails.player1Id,
          playerImage: this.contestDetails.player1Image,
          selected: false
        },
        {
          name: this.contestDetails.player2Name,
          id: this.contestDetails.player2Id,
          playerImage: this.contestDetails.player2Image,
          selected: false
        }
      ];
      this.showPlayers = true;
    },
      err => {
        console.log(err);
      });
  }

  contestPlayerName(playerName) {
    if (playerName.split('/').length !== 2) {
      playerName = playerName.split(' ').filter(ele => ele.length > 2)[0];
    } else {
      playerName = playerName.split('/')[0].split(' ')[0]+' & '+playerName.split('/')[1].split(' ')[1];
    }
    return playerName;
  }

  getQuestionList() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByContestId" + this.contestId;
    this.questionService.getQuestionAnswerList(query).subscribe(
      data => {
        this.loading = false;
        this.questionsList = data.data.items;
        this.questionsList.forEach(element => {
          element['selected'] = false;
          element['disable'] = false;
        });
        this.totalRecords = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  findIndexByQuestionId(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].questionId === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  encodeStr(str: string): string {
    return str.replace(/\//g, '<span class="class-slash">/</span>');
  }
}
